import React from "react";
import { HomePageCarSearch } from "@capone/portal";
import { HomePageCarSearch as CorpHomePageCarSearch } from "@capone-corporate/portal";
import { isCorpTenant } from "@capone/common";
import { config } from "../../api/config";

export const CarSearch = ({ className }: { className?: string }) => {
  if (isCorpTenant(config.TENANT)) {
    return <CorpHomePageCarSearch className={className} />;
  }
  return <HomePageCarSearch className={className} />;
};
